import { render, staticRenderFns } from "./score.vue?vue&type=template&id=ed20b99a&"
import script from "./score.vue?vue&type=script&lang=js&"
export * from "./score.vue?vue&type=script&lang=js&"
import style0 from "./score.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports